import { IPagination } from "../interfaces/common/IPagination";
import { IAuditListFilters } from "../interfaces/IAudit";

const KEY_BASE = "auditoinnit"

export const AuditoinnitCacheKeys = (token?: string, lang?: string) => ({
    AuditPage: (pagination: IPagination, filters: Partial<IAuditListFilters>) => [KEY_BASE, "auditsPage", pagination.page, JSON.stringify(filters)],
    AuditMap: (filters: Partial<IAuditListFilters>) => [KEY_BASE, "auditMap", JSON.stringify(filters)],

    AuditItemInstance: (id: number) => [KEY_BASE, "auditsItem", id],

    AuditCounts: (search: IAuditListFilters) => [KEY_BASE, "auditCounts", search.region, search.target, search.area, JSON.stringify(search.roles)],
    AuditInstance: (id: string) => [KEY_BASE, "audit", id],
    MakeAuditPackageInstance: (id: number | string) => [KEY_BASE, lang, "auditPacakge", id],
    AuditPackageDataInstance: (id: string) => [KEY_BASE, lang, "auditPacakgeData", id],

    InitialData: KEY_BASE + lang + ":initialData",
    AppRoles: KEY_BASE + ":appRoles",
    FormDefinitionInstance: (id: number) => [KEY_BASE, lang, "formDefinition", id],


    ObservationContext: KEY_BASE + lang + ":observationContext",
    ObservationFormDefinitionInstance: (id: number | string) => [KEY_BASE, lang, "observation:formDefinition", id],
});